import * as wx from "../../../common/jweixin";
import { getWxConfig } from '@/api/common/index';
import { getPosition } from '../../../../utils/http'
export default {
  data() { },
  methods: {
    isWeiXin() {
      var ua = window.navigator.userAgent.toLowerCase();
      return ua.match(/MicroMessenger/i) == 'micromessenger'
    },

    getLocation(callBack) {
      if (this.isWeiXin()) {
        this.getInfo(callBack);
      }
      // 测试
      // this.getUserLocation({latitude: 39.85856,longitude: 116.28616},callBack)


    },
    // 获取个人位置信息
    getInfo(callBack) {
      const pageUrl = window.location.href.split('#')[0];
      getWxConfig({ pageUrl }).then(res => {
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.appid, // 必填，公众号的唯一标识
          timestamp: res.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.nonceStr, // 必填，生成签名的随机串
          signature: res.signature, // 必填，签名
          jsApiList: ["openLocation", "getLocation"], // 必填，需要使用的JS接口列表
          openTagList: ['wx-open-launch-weapp']
        });
        wx.ready(() => {
          try {
            wx.getLocation({
              type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
              success: (res) => {
                var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
                var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
                this.getUserLocation({ longitude, latitude }, callBack);
              },
            });
          } catch (e) {
          }
        })
      })
    },
    // 获取个人位置
    /**
     * longitude	是	Double	经度
     * latitude   是	Double	纬度
     */
    getUserLocation({ longitude, latitude }, callBack) {
      getPosition({ longitude, latitude }).then(res => {
        if (res && res.result) {
          const { province } = res.result.ad_info;
          this.dataForm.area = province
          callBack && callBack()
          this.getIndustryCollegesRequest()
        }
      })
    },
  }
}


